export default __webpack_public_path__ + "static/media/sponsor-icon-active.7b6e22d8.webp";